import { MemberSubmissionTypeEnum } from '../models/users/enum/member-submission-type-enum';
import { EmployerSubmissionTypeEnum } from '../models/users/enum/employer-submission-type.enum';

export class SubmissionPermissionUtils {
  static getViewMemberSubmissionPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 1;
      case MemberSubmissionTypeEnum.AddressChange:
        return 7;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 13;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 19;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 25;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 31;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 37;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 43;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 49;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 73;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 79;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 85;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 91;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 97;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 103;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 109;
      case MemberSubmissionTypeEnum.TransferIn:
        return 115;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getProcessMemberSubmissionPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 2;
      case MemberSubmissionTypeEnum.AddressChange:
        return 8;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 14;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 20;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 26;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 32;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 38;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 44;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 50;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 74;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 80;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 86;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 92;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 98;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 104;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 110;
      case MemberSubmissionTypeEnum.TransferIn:
        return 116;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveMemberSubmissionPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 3;
      case MemberSubmissionTypeEnum.AddressChange:
        return 9;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 15;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 21;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 27;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 33;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 39;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 45;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 51;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 75;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 81;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 87;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 93;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 99;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 105;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 111;
      case MemberSubmissionTypeEnum.TransferIn:
        return 117;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveOwnMemberSubmissionPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 4;
      case MemberSubmissionTypeEnum.AddressChange:
        return 10;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 16;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 22;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 28;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 34;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 40;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 46;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 52;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 76;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 82;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 88;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 94;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 100;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 106;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 112;
      case MemberSubmissionTypeEnum.TransferIn:
        return 118;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanReassignMemberSubmissionOwnerPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 5;
      case MemberSubmissionTypeEnum.AddressChange:
        return 11;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 17;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 23;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 29;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 35;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 41;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 47;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 53;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 77;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 83;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 89;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 95;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 101;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 107;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 113;
      case MemberSubmissionTypeEnum.TransferIn:
        return 119;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanCreateMemberSubmissionPermission(submissionTypeId: MemberSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case MemberSubmissionTypeEnum.NameChange:
        return 6;
      case MemberSubmissionTypeEnum.AddressChange:
        return 12;
      case MemberSubmissionTypeEnum.UpdateContactInfo:
        return 18;
      case MemberSubmissionTypeEnum.PersonalInfoChange:
        return 24;
      case MemberSubmissionTypeEnum.ChangeInvestmentInstructions:
        return 30;
      case MemberSubmissionTypeEnum.RelationshipStatusChange:
        return 36;
      case MemberSubmissionTypeEnum.DefinedContributionBeneficiaryChange:
        return 42;
      case MemberSubmissionTypeEnum.BankingInformation:
        return 48;
      case MemberSubmissionTypeEnum.UpdateLegalFiduciary:
        return 54;
      case MemberSubmissionTypeEnum.VariableBenefitConfiguration:
        return 78;
      case MemberSubmissionTypeEnum.UpdateVariableBenefitConfiguration:
        return 84;
      case MemberSubmissionTypeEnum.VariableBenefitPaymentChange:
        return 90;
      case MemberSubmissionTypeEnum.VariableBenefitBeneficiaryChange:
        return 96;
      case MemberSubmissionTypeEnum.MonthlyPensionSetup:
        return 102;
      case MemberSubmissionTypeEnum.UpdateMonthlyPensionBeneficiaries:
        return 108;
      case MemberSubmissionTypeEnum.AddPaylineAccount:
        return 114;
      case MemberSubmissionTypeEnum.TransferIn:
        return 120;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getViewEmployerSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 55;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 61;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 67;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 121;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getProcessEmployerSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 56;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 62;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 68;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 122;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveEmployerSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 57;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 63;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 69;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 123;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveOwnEmployerSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 58;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 64;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 70;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 124;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanReassignEmployerSubmissionOwnerPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 59;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 65;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 71;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 125;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanCreateEmployerSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.AddNewEmployer:
        return 60;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 66;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 72;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 126;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }
}
